$(document).on('click', '.faq h5', function(){
    $(this).closest('.faq').toggleClass('openFaq')
    $(this).closest('.faq').find('.faqDescription').slideToggle()
})